import API from 'services/TAPS_API';

export default function confirmQSA(data) {
  return API.request({
    method: 'POST',
    url: '/notification/qesIssue/confirm',
    data,
  });
}
